import { TFunction } from "i18next";

export const getCalendarMessages = (t: TFunction) => ({
  date: t("calendarMessages.date"),
  time: t("calendarMessages.time"),
  event: t("calendarMessages.event"),
  allDay: t("calendarMessages.allDay"),
  week: t("calendarMessages.week"),
  work_week: t("calendarMessages.workWeek"),
  day: t("calendarMessages.day"),
  month: t("calendarMessages.month"),
  previous: t("calendarMessages.previous"),
  next: t("calendarMessages.next"),
  yesterday: t("calendarMessages.yesterday"),
  tomorrow: t("calendarMessages.tomorrow"),
  today: t("calendarMessages.today"),
  agenda: t("calendarMessages.agenda"),
  noEventsInRange: t("calendarMessages.noEventsInRange"),
  showMore: (total: number) =>
    t("calendarMessages.showMore", { count: total }),
});